import React, { useMemo } from "react";
import { MaterialReactTable } from "material-react-table";

import { formatCurrency } from "../../Utils/Currency";
import { Loader } from "../../Utils/Loader";
import SOItemTable from "./SOItemTable";

function SOTable({
  soData,
  totalCount,
  pagination,
  onPaginationChange,
  loading,
  columns,
  salesorderPermission,
  onEdit,
  onRequest,
  onApprove,
  onStockOut,
}) {
  return (
    <div
      className="border table-responsive"
      style={{ borderRadius: "4px", position: "relative" }}
    >
      {loading && <Loader />}

      <MaterialReactTable
        columns={columns}
        data={soData}
        state={{ pagination }}
        onPaginationChange={onPaginationChange}
        manualPagination
        rowCount={totalCount || 0}
        columnResizeMode="on"
        defaultColumn={{
          minSize: 40,
          maxSize: 1000,
          size: 150,
        }}
        muiTableProps={{
          sx: {
            tableLayout: "fixed",
            width: "100%",
          },
        }}
        enableTopToolbar={false}
        enableDensityToggle={false}
        enableColumnActions={false}
        enableFullScreenToggle={false}
        enableColumnFilters={false}
        enablePagination
        enableExpandAll={false}
        enableExpanding
        paginateExpandedRows={false}
        positionExpandColumn="first"
        displayColumnDefOptions={{
          "mrt-row-expand": {
            header: "",
            size: 50,
            minSize: 50,
            maxSize: 50,
          },
        }}
        muiExpandButtonProps={({ row }) => ({
          children: row.getIsExpanded() ? (
            <i className="ri-arrow-up-s-line fs-5"></i>
          ) : (
            <i className="ri-arrow-down-s-line fs-5"></i>
          ),
        })}
        initialState={{
          density: "comfortable",
        }}
        renderDetailPanel={({ row }) => {
          const items = (row.original.itemData || []).map((item) => ({
            ...item,
            parentData: row.original,
          }));

          return (
            <SOItemTable
              items={items}
              salesorderPermission={salesorderPermission}
              onEdit={onEdit}
              onRequest={onRequest}
              onApprove={onApprove}
              onStockOut={onStockOut}
            />
          );
        }}
        muiTablePaperProps={{
          elevation: 0,
          sx: {
            borderRadius: "0px",
            boxShadow: "none",
          },
        }}
      />
    </div>
  );
}

export default SOTable;
